var map = {
	"./assets/iconos/favicon.png": [
		9231,
		231
	],
	"./assets/iconos/ipv.png": [
		711,
		711
	],
	"./assets/iconos/logo-cidi.png": [
		7199,
		199
	],
	"./assets/img/MARCELOORREGO-BRILLANTE.png": [
		9078,
		78
	],
	"./assets/img/banner-capacitacion.png": [
		6218
	],
	"./assets/img/favicon.png": [
		4184,
		184
	],
	"./assets/img/logo_ciudadano_digital.png": [
		9027
	],
	"./assets/img/logoblanco-s.png": [
		9298,
		298
	],
	"./assets/img/moratoriadgr.png": [
		6138,
		138
	],
	"./assets/img/portada.png": [
		2537
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3880;
module.exports = webpackAsyncContext;